import {
  Constructor,
  EdgeStyleBase,
  IEdge,
  IInputModeContext,
  IObstacleProvider,
  IRenderContext,
  Point,
  Visual,
} from '@ardoq/yfiles';
import { hasColorAttributes, type GraphEdgeBase } from '@ardoq/graph';
import { colors } from '@ardoq/design-tokens';
import { CanvasEdgeVisual } from './CanvasEdgeVisual';
import { lineTypeDashArrays } from 'tabview/canvasRendering/consts';
import { createPath } from 'yfilesExtensions/edgeUtil';
import { BasicEdgeObstacleProvider } from 'yfilesExtensions/BasicEdgeObstacleProvider';

class CanvasEdgeStyle extends EdgeStyleBase {
  static Instance = new CanvasEdgeStyle();
  private constructor() {
    super();
  }

  protected override createVisual(
    _: IRenderContext,
    edge: IEdge
  ): Visual | null {
    const graphEdge = edge.tag as GraphEdgeBase;

    const { stroke = colors.black950 } = hasColorAttributes(graphEdge)
      ? graphEdge.getCssColorAttributes()
      : {};

    const lineType = graphEdge.getLine();
    const dashArray = lineTypeDashArrays[lineType];
    const lineBeginning = graphEdge.getLineBeginning();
    const lineEnding = graphEdge.getLineEnding();
    return new CanvasEdgeVisual(
      edge,
      stroke,
      dashArray,
      lineBeginning,
      lineEnding,
      graphEdge.isTransparentized ? 0.3 : 1
    );
  }
  protected override getPath(edge: IEdge) {
    return createPath(edge, false);
  }
  protected override isHit(
    _: IInputModeContext,
    location: Point,
    edge: IEdge
  ): boolean {
    const hitTestRadius = 13; // the hover path is 25px wide, set in CSS.  if the hover path is showing, this should be a hit.
    return this.getPath(edge).pathContains(location, hitTestRadius);
  }
  override lookup(edge: IEdge, type: Constructor) {
    if (type === IObstacleProvider) {
      return new BasicEdgeObstacleProvider(edge);
    }
    return super.lookup(edge, type);
  }
}
export { CanvasEdgeStyle };
